<template lang="pug">
.charts
    #mapchart(ref="mapchart", v-show="!isOptionEmpty")
    .emptychart(v-show="isOptionEmpty")
    .loadingchart(v-show="isLoading")
</template>

<script>
import { mapChartOptionFactory } from './options.js'
import resizeMixin from './resize.mixin.js'

export default {
    mixins: [resizeMixin],
    props: {
        series: Array,
        // 系列名称
        name: String,
        height: {
            type: [Number, String],
            default: 300
        }
    },
    data() {
        return {
            timer: null,
            chart: null
        };
    },
    computed: {
      isOptionEmpty: function() {
        return _.isEmpty(this.series)
      },
      isLoading() {
        return this.$store.state.chartLoading
      }
    },
    methods: {
        initChart() {
            let dom = this.$refs.mapchart
            if(dom){
              this.chart = echarts.init(dom, null, {height: this.height})
            }
        },
        draw() {
            if (!this.isOptionEmpty && !this.chart) {
                this.initChart()
            }
            if (this.chart) {
                this.chart.setOption(mapChartOptionFactory({
                    seriesItems: this.series,
                    seriesName: this.name
                }))
            }
        }
    },
    updated(){
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.draw(), 200);
    },
    mounted(){
      this.draw()
    },
    destroyed() {
      this.chart = null
      clearTimeout(this.timer);
    }
}
</script>



// WEBPACK FOOTER //
// mapChina.vue?00b85074